import { AppType } from '../utils';

const util = {};

util.flatten = function(array){
    let l = [];
    for (const element of array) {
        if (Array.isArray(element)){
            l = l.concat(util.flatten(element));
        } else{
            l.push(element);
        }
    }
    return l;
};

util.widgetsOfType = function(context, type){
    let allWidgets = util.extractWidgetsWithPageInfo(context.pages);

    if (context.appTypeId === AppType.LOCKDOWN && !!context.sliderChildren) {
        const sliderChildWidgets = util.extractWidgetsWithPageInfo(context.sliderChildren);
        allWidgets = allWidgets.concat(sliderChildWidgets);
    }

    let flattened = util.flatten(allWidgets);
    let filtered = flattened.filter(function(x){return !type || x.type === type});
    return filtered;
};

util.extractWidgetsWithPageInfo = function(list) {
    return list.map(item =>
        item.widgets.map(widget => {
            widget.page = { name: item.name, id: item.id, formName: item.formName };
            return widget;
        })
    );
};

util.parseString = function(str){
    if (typeof str !== 'string'){
        return '' + str;
    }

    if ((str.startsWith("'") && str.endsWith("'")) || (str.startsWith('"') && str.endsWith('"')) ){
        str = str.substring(1);
        str = str.substring(0,str.length-1);
    }
    return str;
}

export default util